import { useEffect, useMemo, useState } from 'react';

import { useUsers } from '../../../queries/user';
import { NominatedGroup } from '../../../schemas/nominations';
import { getUserTag } from '../../../schemas/users';

export const GROUP_MEMBER_PREVIEW_LIMIT = 10;

export type GroupMemberPreviewRow = {
	id: string;
	label: string | undefined;
};

export function useGroupMemberPreview(nominatedGroup: NominatedGroup | null | undefined) {
	const { data: groupMembers, isLoading: isLoadingMembers } = useUsers(nominatedGroup?.userIds?.length ? nominatedGroup.userIds : undefined);
	const [showAllGroupMembers, setShowAllGroupMembers] = useState(false);

	useEffect(() => {
		setShowAllGroupMembers(false);
	}, [nominatedGroup?.groupType, nominatedGroup?.key]);

	const orderedGroupMemberRows = useMemo((): GroupMemberPreviewRow[] => {
		if (!nominatedGroup?.userIds.length || !groupMembers) {
			return [];
		}

		const byId = new Map(groupMembers.map((u) => [u.id, u]));

		return nominatedGroup.userIds.map((id) => {
			const user = byId.get(id);

			return {
				id,
				label: user?.displayName ?? (user ? getUserTag(user.username) : undefined),
			};
		});
	}, [nominatedGroup, groupMembers]);

	return {
		isLoadingMembers,
		orderedGroupMemberRows,
		previewLimit: GROUP_MEMBER_PREVIEW_LIMIT,
		showAllGroupMembers,
		setShowAllGroupMembers,
	};
}
